import { GlobalState } from './state';

export const $ = new GlobalState();

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
window.wardrobe = $;
